<script setup lang="ts">
interface PropsType {
	show?: boolean;
	title?: string;
	width?: string;
	showButtonConfirm?: boolean;
	buttonConfirm?: string;
	buttonClose?: string;
	buttonType?: string;
}

defineEmits(["close", "confirm"]);

withDefaults(defineProps<PropsType>(), {
	show: false,
	title: "",
	width: "80%",
	showButtonConfirm: false,
	buttonClose: "Fechar",
	buttonConfirm: "Confirmar",
	buttonType: "default",
});
</script>

<template>
	<Teleport to="body">
		<section v-if="show" class="modal">
			<div class="modal-body shadow" :style="{ width: width }">
				<template v-if="$slots.title">
					<slot name="title"></slot>
				</template>
				<template v-else>
					<template v-if="title">
						<div class="title" v-html="title"></div>
					</template>
				</template>

				<div class="content">
					<slot name="content"></slot>
				</div>

				<template v-if="$slots.actions">
					<div class="actions">
						<slot name="actions"></slot>
					</div>
				</template>

				<template v-else>
					<div class="actions">
						<button
							v-if="showButtonConfirm"
							class="btn btn-primary btn-md"
							@click="$emit('confirm')"
						>
							{{ buttonConfirm }}
						</button>
						<button class="btn btn-default btn-md" @click="$emit('close')">
							{{ buttonClose }}
						</button>
					</div>
				</template>
			</div>
		</section>
	</Teleport>
</template>

<style lang="scss" scoped>
.modal {
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	width: 100vw;
	height: 100vh;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: var(--black-transparent);
	z-index: 99;

	.modal-body {
		display: flex;
		flex-direction: column;
		background: #fff;
		padding-block: 1rem;
		padding-inline: 1.5rem;
		border-radius: 0.5rem;

		.title {
			font-size: 1.2rem;
			font-weight: bold;
			padding-block-end: 1rem;
		}

		.content {
			width: 100%;
			overflow-y: auto;
			max-height: 65vh;
			font-size: 1rem;
			padding-block-end: 1rem;
			padding-inline-end: 0.25rem;
		}

		.actions {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			gap: 1rem;
			padding-block-start: 0.5rem;
		}
	}
}
</style>
